import { motion } from "framer-motion";
import {ShieldCheck} from 'lucide-react';

export default function GuaranteeSection() {
  return (
    <section className="relative bg-blue-900 py-16 md:py-20 overflow-hidden">
      {/* Bandeiras desbotadas no fundo */}
      <div className="absolute top-8 left-8 opacity-5 text-9xl select-none pointer-events-none">
        &#127482;&#127480;
      </div>
      <div className="absolute bottom-8 right-8 opacity-5 text-9xl select-none pointer-events-none">
        &#127468;&#127463;
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex-1 text-center lg:text-left">

            <h2 className="font-serif-display text-3xl md:text-4xl font-bold text-white leading-tight mb-6">
              Teste por 6 meses.
              <br />
              <span className="text-yellow-400">Se você aplicar o método e não sair do básico, devolvemos 100% do seu dinheiro.

              </span>
            </h2>
            <p className="text-blue-200 text-lg mb-2">Sem letras miúdas.</p>
            <p className="text-blue-200 text-lg mb-6">Sem enrolação.</p>
            <p className="text-white text-2xl font-bold">A gente só ganha se você evoluir.

            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex-shrink-0">

            <div className="relative w-48 h-48 md:w-56 md:h-56">
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-400 via-amber-500 to-yellow-600 rounded-full shadow-2xl shadow-yellow-500/30 flex items-center justify-center p-1.5 animate-float">
                <div className="bg-blue-900 rounded-full w-full h-full flex flex-col items-center justify-center p-4 text-center border-4 border-yellow-400">
                  <ShieldCheck className="w-12 h-12 text-yellow-400 mb-2" />
                  <p className="text-white text-sm md:text-base font-bold leading-tight">
                    GARANTIA
                  </p>
                  <p className="text-yellow-400 text-lg md:text-xl font-bold">
                    6 MESES
                  </p>
                  <p className="text-blue-200 text-xs mt-1">
                    100% do dinheiro de volta
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>);

}